import React from 'react';
import * as motion from "motion/react-client"
import StickyNavbar from '../navbar';
import { Link } from 'react-router-dom';

const ChapterOneVideo = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <div>
      <StickyNavbar />
      <div className="bg-white text-lg text-black p-4 lg:mt-10 mt-20 sm:p-10 lg:px-20 w-full">
        <motion.div
          className="text-center mb-8"
          initial="hidden"
          animate="visible"
          variants={fadeIn}
        >
          <motion.h1
            className="text-2xl sm:text-3xl lg:text-4xl font-bold"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            Chapter 1: Introduction to Research
          </motion.h1>

          <motion.div
            className="mt-6 flex items-center justify-center m-auto "
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
          >
            <iframe
              width="65%"
              height="630"
              src="https://res.cloudinary.com/dk56u1huz/video/upload/v1740867141/Chapter_1_Introduction_to_Research_gnpuqj.mp4"
              title="Introduction to Research"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="rounded-lg"
            ></iframe>
          </motion.div>

        </motion.div>


        <Link to="/chapter1">
          <motion.div
            className="flex justify-center mt-10"
            whileHover={{ scale: 1.1 }}
          >
            <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
              Next
            </button>
          </motion.div>
        </Link>
      </div>
    </div>
  );
};

export default ChapterOneVideo;
